import styled from 'styled-components';

export const SectionElem = styled.section`
  ${({ theme }) => `
    display: flex;
    width: 100%;
    margin: 0 0 ${theme.layout.spacing.deka};
    flex-flow: column nowrap;
    justify-content: flex-start;
  `};
`;
